<template>
        <section id="photobookSeries">
          <div class="inner4">
            <h3>シリーズ紹介</h3>
            <div class="photobookSeries">
              <article>
                <h4>東京カメラ部2019写真展 公式写真集<br><span>世界は発見を待っている。</span></h4>
                <img src="/img/photobookCover2019.jpg" srcset="/img/photobookCover2019@2x.jpg 2x" alt="東京カメラ部2019写真展 公式写真集">
                <p>ネット上で多くの「いいね！」を集めている気鋭の写真家たちによる、時代を象徴する写真約180点を掲載した公式写真集第３弾。〔全国学校図書館協議会選定図書〕<br>(196ページ、ISBN:9784863134560)<br>
                本体1,389円＋税</p>
                <a target="_blank" @click="logger('2019')" href="https://natgeo.nikkeibp.co.jp/atcl/product/19/051500019">購入はこちらから</a>
              </article>
              <article>
                <h4>東京カメラ部2018写真展 公式写真集<br><span>世界はもっと美しい。</span></h4>
                <img src="/img/photobookCover2018.jpg" srcset="/img/photobookCover2018@2x.jpg 2x" alt="東京カメラ部2018写真展 公式写真集">
                <p>「インスタグラム部門」の写真も掲載。本当に“インスタ映え”する写真は、どのようなものか。本書でわかります。公式写真集第２弾。<br>(296ページ、ISBN:9784863134089)<br>
                本体1,759円＋税</p>
                <a target="_blank" @click="logger('2018')" href="https://natgeo.nikkeibp.co.jp/atcl/product/18/041300006/">購入はこちらから</a>
              </article>
            </div>
          </div>
        </section>
</template>

<script>
export default {
  methods: {
    logger (type) {
      // イベント記録
      this.$ga.event('Photobook', type, 'National Geographic', null)
    }
  }
}
</script>
